import React from 'react';
import HeaderFooterwithCookies from '../../common/openPages/HeaderFooterwithCookies';
import PingSignUp from './PingSignUp';

function PingSignUpIndex() {
  return (
    <HeaderFooterwithCookies cookiesEnabled>
      <PingSignUp />
    </HeaderFooterwithCookies>
  );
}

export default PingSignUpIndex;